import axios from 'Axios';

export default {
  getTicket(id) {
    return axios.get('/supply/ticket/' + id);
  },
  createSlip(ticketId, data) {
    return axios.post(`/ticket/${ticketId}/slip`, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
